/*

ashraf 10/16/2022  2700614626  added code comments in search, add user management.
ashraf 10/27/2022  2700614626  user management ux changes
ashraf 12/14/2022  2700614626  added role based access to unlock user
Akhila 06/05/2023 2700614626 unsaved changes bug fixed/implemented
*/

import React, {useRef} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import SearchUser from './SearchUser';
import AddUser from './AddUser';
import SearchForm from './UnlockUser';
import useUnsavedChangesWarning from '../../util/CustomHooks';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: '100%',
    borderRadius: '5px',
  },
  padding: {
    padding: theme.spacing(3),
  },
  demo1: {
    backgroundColor: '#296bff',
    color: 'white',
    borderRadius: '6px',
  },
}));

// user management search users, add user, unlock users components render (2700614626)
export default function UserManagementTabs() {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);
  const [selected, setSelected] = React.useState('');
  const [companyCode, setCompanyCode] = React.useState([]);
  const showAlertRef = useRef(false);
  const {onDirty, onPristine} = useUnsavedChangesWarning();

  const changeDirty = useRef(true);
  const handleDirty = (dirty, isFixed) => {
    if (isFixed === 'fixed') {
      showAlertRef.current = dirty;
      changeDirty.current = false;
      if (dirty) {
        onDirty();
      } else {
        onPristine();
      }
    }
    if (isFixed === 'reset') {
      showAlertRef.current = false;
      changeDirty.current = true;
      onPristine();
    }
    if (changeDirty.current) {
      showAlertRef.current = dirty;
      if (dirty) {
        onDirty();
      } else {
        onPristine();
      }
    }
  };
  const alertProps = {
    showAlertRef,
    handleDirty,
  };

  return (
    <div className={classes.root}>
      <div className={classes.subContent}>
        {value === 0 && (
          <SearchUser
            selected={selected}
            setSelected={setSelected}
            setValue={setValue}
            companyCode={companyCode}
            setCompanyCode={setCompanyCode}
          />
        )}
      </div>
      <div className={classes.subContent}>
        {value === 1 && (
          <AddUser
            value={value}
            selected={selected}
            setValue={setValue}
            companyCode={companyCode}
            setCompanyCode={setCompanyCode}
            {...alertProps}
          />
        )}
      </div>
      <div className={classes.subContent}>{value === 2 && <SearchForm setValue={setValue} />}</div>
    </div>
  );
}
